<template>
  <div class="flex">
    <AnimatePresence>
      <Motion
        v-if="lgAndLarger || isMobileMenuVisible"
        as-child
        :initial="{ x: '-100%' }"
        :animate="{ x: 0 }"
        :exit="{ x: '-100%' }"
        :transition="{
          duration: 0.3,
          ease: [0, 0.71, 0.2, 1.01],
        }"
      >
        <AppSidebar
          :model="menu"
          class="overflow-hidden rounded-r-xl transition-shadow lg:rounded-r-none"
          :class="{
            'shrink-0': lgAndLarger,
            '!fixed left-0 top-0': !lgAndLarger,
            'shadow-2xl': isMobileMenuVisible,
          }"
        >
          <template
            v-if="$slots['app-sidebar-header']"
            #header
          >
            <slot name="app-sidebar-header" />
          </template>

          <template
            v-if="$slots['app-sidebar-body']"
            #body
          >
            <slot name="app-sidebar-body" />
          </template>

          <template
            v-if="$slots['app-sidebar-footer']"
            #footer
          >
            <slot name="app-sidebar-footer" />
          </template>
        </AppSidebar>
      </Motion>

      <Motion
        v-if="isMobileMenuVisible"
        as-child
        :initial="{ opacity: 0 }"
        :animate="{ opacity: 1 }"
        :exit="{ opacity: 0 }"
      >
        <div
          class="bg-surface-100/5 fixed inset-0 z-50 cursor-pointer backdrop-blur-sm dark:bg-white/10"
          @click="layoutStore.closeMobileMenu()"
        />
      </Motion>
    </AnimatePresence>

    <slot />
  </div>
</template>

<script lang="ts" setup>
import AppSidebar from '~/components/layouts/default/AppSidebar.vue'
import { lgAndLarger } from '~/composables/useUI'
import { useLayoutStore } from '~/store/layout'
import type { MenuItem } from '~/types/app'

defineProps<{
  menu: MenuItem[]
}>()

const layoutStore = useLayoutStore()
const { isMobileMenuVisible } = storeToRefs(layoutStore)

const route = useRoute()
const toast = usePrimevueToast()
watch(() => route.fullPath, () => {
  toast.removeAllGroups()
  if (isMobileMenuVisible.value) layoutStore.closeMobileMenu()
})

watch(lgAndLarger, (isLarger) => {
  if (isLarger && isMobileMenuVisible.value) layoutStore.closeMobileMenu()
})
</script>
